import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router-dom';
import { getDetails } from "../api/merchantAPI";
import MainPage from "./MainPage";
import NotFoundPage from './NotFoundPage';


export default function Index() {

    const { code } = useParams();
    
    const [merchantDetails, setMerchantDetails] = useState({});
    const [isValid, setIsValid] = useState(null);


    useEffect(() => {
        async function getMerchantDetails() {
            try {
                let getInfo = await getDetails(code);
                if (getInfo.MerchantId) {
                    setIsValid(true)
                    setMerchantDetails(getInfo);
                    return;
                } else {
                    setIsValid(false);
                    return;
                }
            } catch (error) {
                setIsValid(false);
                return;
            }
        }
        if (code) {
            getMerchantDetails();
        }
    }, [code]);

    if (isValid === false) {
        return (
            <NotFoundPage />
        )
    }

    return (
        <>
            {isValid && <MainPage merchantDetails={merchantDetails} />}
        </>
    )
}
